import { Divider, FormControl, Grid, MenuItem, Select } from '@mui/material';
import React from 'react';
import { prepareModelSelectOptions } from 'components/TeamOverview/components/AiComputeTransactionsCard/utilities';
import { EMPTY_SELECT_OPTION } from 'components/TeamOverview/components/AiComputeTransactionsCard/constants';
import { useModelFilterDropdownStyles } from 'components/TeamOverview/components/AiComputeTransactionsCard/styles';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import CheckIcon from '@mui/icons-material/Check';

export const ModelFilterDropdown = ({
  models,
  handleModelFilterChange,
  modelFilter,
}) => {
  const { classes } = useModelFilterDropdownStyles();

  const modelSelectOptions = prepareModelSelectOptions(models);

  return (
    <FormControl
      classes={{
        root: classes.selectRoot,
      }}
    >
      <Select
        variant="outlined"
        value={modelFilter}
        onChange={handleModelFilterChange}
        style={{ height: 40 }}
        renderValue={(selected) => {
          const selectedOption = modelSelectOptions.find(
            (option) => option.value === selected,
          );

          return selectedOption ? (
            <Grid container alignItems="center">
              <Grid xs={2} className={classes.verticalCenter}>
                <img
                  alt="logo"
                  src={selectedOption.logo}
                  className={classes.serviceLogo}
                />
              </Grid>
              <Grid xs={10}>{selectedOption.short}</Grid>
            </Grid>
          ) : (
            <Grid container>
              <Grid xs={2} className={classes.verticalCenter}>
                <FilterAltOffIcon
                  className={`${classes.serviceLogo} ${classes.noFilterIcon}`}
                />
              </Grid>
              <Grid xs={10} className={classes.verticalCenter}>
                {EMPTY_SELECT_OPTION.short}
              </Grid>
            </Grid>
          );
        }}
      >
        <MenuItem
          value={EMPTY_SELECT_OPTION.value}
          classes={{
            root: classes.menuItemRoot,
            selected: classes.menuItemSelected,
          }}
        >
          <Grid container>
            <Grid xs={2} className={classes.verticalCenter}>
              <FilterAltOffIcon
                className={`${classes.serviceLogo} ${classes.noFilterIcon}`}
              />
            </Grid>
            <Grid xs={10} className={classes.verticalCenter}>
              {EMPTY_SELECT_OPTION.short}
            </Grid>
          </Grid>
        </MenuItem>
        <Divider />
        {modelSelectOptions.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            classes={{
              root: classes.menuItemRoot,
              selected: classes.menuItemSelected,
            }}
          >
            <Grid container>
              <Grid xs={2} className={classes.verticalCenter}>
                <img
                  alt="logo"
                  src={option.logo}
                  className={classes.serviceLogo}
                />
              </Grid>
              <Grid xs={9} className={classes.verticalCenter}>
                {option.short}
              </Grid>
              <Grid xs={1} className={classes.verticalCenter}>
                {modelFilter === option.value && (
                  <CheckIcon fontSize={'small'} />
                )}
              </Grid>
            </Grid>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
